import { Enviroment } from '../../../../../_config/constants/enviroment-v2.constant';
import CustomSteps from '../../../../../v2-components/Antd/Steps';
import { status } from './constants/status.constant';
import { handleDescription } from './handle/description.handle';

export default function TrackingProgress(props) {

	const progress = props?.data?.status_tracking_history;

	const isViewed = props?.data?.quotation_cart_viewed;


	const filteredStatus = status[Enviroment.LANGUAGE].filter((s) => progress?.some((p) => p.status === s.status));

	const steps = filteredStatus.map((item, index) => {
		const description = progress.filter((item) => item.status === filteredStatus[index].status);
		let titleContent = item.description;
    if (item.status === 400 && isViewed) {
      titleContent = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {item.description}
          <span style={{
            backgroundColor: '#ff5c00',
            color: 'white',
            fontSize: '10px',
            padding: '2px 8px',
            borderRadius: '10px',
            fontWeight: '600',
            lineHeight: '1.2',
          }}>
            Leída
          </span>
        </div>
      );
    }

		return {
			title: titleContent,
			description: handleDescription(description),
		};
	});

	const current = steps.length - 1;


	return (
		<div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginRight:'10px' }}>
			<p>
				Farmacia {props?.data?.pharmacy}
			</p>
			<h2>Tracking de pedido</h2>
			<CustomSteps progressDot size="small"  direction="vertical" current={current} items={steps} />
		</div>
	);
}
